import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const DhlLogo: FC<SvgIconProps> = (props) => (
  <SvgIcon width="42" height="41" viewBox="0 0 42 41" {...props}>
    <circle cx="21" cy="20.5" r="20" fill="#FC0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.368 20.181 1.049-1.255s4.643 0 6.014.01c1.521 0 1.913 1.069 1.487 1.578l-.692.83H14.9c-.438 0-.3-.166-.23-.25.088-.104.21-.253.323-.392.077-.094.15-.184.206-.25.15-.177.15-.27-.138-.27H9.368Zm1.67.312-2.096 2.521s3.745 0 5.104.01a3.731 3.731 0 0 0 2.915-1.369h-3.48c-.417 0-.31-.142-.24-.236l.01-.013c.09-.105.21-.254.324-.392l.206-.251c.15-.177.15-.27-.138-.27h-2.604Zm-6.371 1.152h4.862l-.242.29h-4.62v-.29Zm4.413.54H4.667v.29h4.17l.243-.29Zm-4.413.539H8.63l-.23.29H4.666v-.29Zm32.666.29h-4.85l.241-.29h4.61v.29Zm-4.401-.54h4.401v-.29h-4.16l-.241.29Zm.691-.83h3.71v.291h-3.952l.242-.29Zm-12.675 0-1.14 1.37h-2.996l1.14-1.37h2.996Zm3.192 1.37 1.14-1.37h-2.995l-1.14 1.37h2.995Zm2.12-1.37s-.219.27-.323.395c-.38.446-.046.975 1.187.975h4.817l1.14-1.37h-6.82Zm-.714-.31h-7.34l2.005-2.408h2.996l-1.141 1.38h1.337l1.152-1.38h2.996l-2.005 2.407Zm4.148 0 2.005-2.408h-3.18l-2.005 2.407h3.18Z"
      fill="#D40511"
    />
  </SvgIcon>
)
